export default function ProfileQuality({ quality }) {
  return (
    <div className="ai-quality-card">
      <h3 className="ai-card-title">⭐ Profile Quality Report</h3>

      <div className="ai-score-box">
        <span>Score</span>
        <strong>{quality.score}/100</strong>
      </div>

      <div className="ai-quality-section success">
        <h4>Strengths</h4>
        <p>{quality.strengths}</p>
      </div>

      <div className="ai-quality-section warning">
        <h4>Weaknesses</h4>
        <p>{quality.weaknesses}</p>
      </div>

      <div className="ai-quality-section info">
        <h4>Suggestions</h4>
        <p>{quality.suggestions}</p>
      </div>
    </div>
  );
}
